module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-pure.js
// module id = 95
// module chunks = 1